<template>
  <div class="group-items pt-1" ref="outfitBuilderContainer">
    <div class="outfit-row" :class="{ 'floating-shadow': shrinkImage }">
      <b-row>
        <b-col cols="12" class="d-flex justify-content-between">
          <div class="outfit-title pb-1 pl-2">
            <input
              class="outfit-title-input"
              type="text"
              placeholder="Add outfit title"
              v-model="outfitTitle"
              autocomplete="false"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="outfit-container" v-if="!success">
            <div
              class="grid-item"
              v-for="outfitItem in builderOutfit"
              :key="outfitItem.sequence"
              @click="clickGridItem(outfitItem)"
              :class="{ 'flex-center': outfitItem.product }"
            >
              <CreateOutfitEmptyOuter
                :outfitHasProducts="outfitHasProducts"
                :shrinkImage="shrinkImage"
                :slug="outfitItem.layerSlug"
                v-if="!outfitItem.product"
              />
              <div class="layer-content-wrapper" v-if="outfitItem.product">
                <div class="layer-image-wrapper">
                  <b-img
                    :src="outfitItem.product.featured_image"
                    class="img-fluid d-block layer-image"
                    :class="{ 'layer-image-shrink': shrinkImage }"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="outfit-container-success" v-else>
            <div class="success-message">
              <svg
                class="checkmark"
                :class="{ active: success }"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 52"
                width="70"
              >
                <circle
                  class="checkmark-circle"
                  cx="26"
                  cy="26"
                  r="23"
                  fill="none"
                />
                <path
                  class="checkmark-check"
                  fill="none"
                  d="M14.1 27.2l7.1 7.2 16.7-16.8"
                />
              </svg>

              <div>
                <h4>Success!</h4>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import CreateOutfitEmptyOuter from "@/components/wardrobe/CreateOutfitEmptyOuter";
import IconOuterwear from "@/components/capsuleBuilder/icons/IconOuterwear";
import { mapActions, mapGetters } from "vuex";
import { bus } from "@/main";

export default {
  components: {
    CreateOutfitEmptyOuter,
    IconOuterwear,
  },

  mounted() {
    this.startingPosition = this.$parent.$refs.sticky.offsetTop;
    window.addEventListener("scroll", this.updateScroll);

    bus.$on("cancelBuilderMode", () => {
      this.closeOutfitBuilder();
    });
  },

  destroy() {
    window.removeEventListener("scroll", this.updateScroll);
  },

  data() {
    return {
      outfitTitle: null,
      startingPosition: null,
      scrollPosition: null,
      shrinkImage: false,
      success: false,
    };
  },

  props: {},

  computed: {
    ...mapGetters(["currentUser", "builderOutfit"]),

    outfitHasProducts() {
      return this.builderOutfit.some((obj) => obj.product);
    },

    shouldShrinkImage() {
      if (this.shrinkImage) {
        if (this.scrollPosition < this.startingPosition + 50)
          this.shrinkImage = false;
      } else {
        if (this.scrollPosition > this.startingPosition + 120)
          this.shrinkImage = true;
      }
    },

    floatingShadow() {
      return this.scrollPosition > this.startingPosition;
    },
  },

  methods: {
    ...mapActions([
      "createWardrobeOutfit",
      "resetBuilderOutfit",
      "setWardrobeBuilderMode",
    ]),

    closeOutfitBuilder() {
      this.setWardrobeBuilderMode(false);

      // INFO: Time out to allow 'close' animation to complete
      setTimeout(() => {
        this.resetBuilderOutfit();
        this.success = false;
        this.outfitTitle = null;
      }, 1500);
    },

    updateScroll() {
      this.scrollPosition = window.scrollY;
      this.shouldShrinkImage;
    },

    clickGridItem(outfitItem) {
      let slug = outfitItem.layerSlug;

      if (outfitItem.layerSlug.includes("accessories")) {
        slug = "accessories";
      }

      let element = this.$parent.$parent.$refs[slug][0];
      let top = window.pageYOffset + element.getBoundingClientRect().top - 250;

      window.scrollTo(0, top);
    },

    submitCreateOutfit() {
      const payload = {
        wardrobeId: this.currentUser.wardrobe_id,
        outfitTitle: this.outfitTitle,
      };

      this.createWardrobeOutfit(payload).then((req) => {
        if (req) {
          this.success = true;

          // INFO: Time out to allow 'success' animation to complete
          setTimeout(() => this.closeOutfitBuilder(), 2000);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

.layer {
  min-width: 13%;
}

.group-items {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  justify-content: center;
}

.outfit-row {
  width: 100%;
  transition: all 0.7s cubic-bezier(0.4, 0, 0.2, 1);

  &.floating-shadow {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);

    &:hover {
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
    }
  }

  .outfit-title {
    width: 100%;
    font-size: 18px;
    line-height: 32px;
    color: white;
    background: $primary-blue;

    .outfit-title-input {
      margin-top: 4px;
      background: $primary-blue;
      border: none;
      color: white;
      width: 100%;

      &::placeholder {
        color: $alizarin;
        font-style: italic;
      }
    }
  }
}

.outfit-container-success {
  padding: 5px;
  background: $grey8;
  border: 1px solid $grey5;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
.outfit-container {
  padding: 5px;
  background: $grey8;
  border: 1px solid $grey5;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  display: grid;
  grid-column-gap: 5px;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  max-height: 100%;
  min-height: 50px;

  @include for-tablet-portrait-up {
    min-height: 97px;
    padding: 15px;
    grid-column-gap: 10px;
  }

  .grid-item {
    * {
      transition: all 0.4s ease-in-out;
    }

    &.flex-center {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .layer-content-wrapper {
      padding: 5px;
      background: white;
      cursor: pointer;
      border-top: 1px solid #ffffff;
      border-radius: 0.3em !important;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
      text-align: center;
      height: 100%;
      width: fit-content;
      transition: box-shadow 0.7s ease-in-out;

      .layer-image {
        max-height: 125px;

        &.layer-image-shrink {
          max-height: 70px;
        }
      }

      &:hover {
        border-top: 1px solid #f2f2f2;
        box-shadow: 0px 5px 5px 0px rgba(169, 169, 169, 1);
      }

      @include for-tablet-portrait-up {
        padding: 10px;
      }
    }
  }
}

.success-message {
  text-align: center;
}

svg.checkmark {
  width: 75px;
  height: 75px;
  margin: 1em auto;
  border-radius: 50%;
  display: block;
  stroke-width: 4;
  stroke: $primary-accent;
  stroke-miterlimit: 10;
  box-shadow: inset 0px 0px 0px #7ac142;
  transition: 1s all ease;
}

/* Trigger animation we add 'active' class via JS */
svg.checkmark.active {
  animation: moveupwards 1s 1s forwards;
}

/* 'Move upwards' animation below, no need for absolutely positioned
          elements or transform: translate. We'll create the subtle 'moving up'
          effect by playing with margins and size. Responsive friendly! */
@keyframes moveupwards {
  0%,
  75% {
    width: 75px;
    height: 75px;
    margin: 1em auto;
  }

  100% {
    width: 50px;
    height: 50px;
    margin: 0.75em auto;
  }
}

/* Paths inside SVG. Each path will be animated using stroke property
          and 'stroke' animation */
svg > .checkmark-circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 3;
  stroke-miterlimit: 10;
  stroke: $primary-accent;
  fill: none;
  animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

svg > .checkmark-check {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-width: 3;
  stroke-dashoffset: 48;
  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}

/* Sorry IE and Edge users, no SVG animations supported for you,
        so we'll hide our SVG to prevent empty space gap */
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .success-message svg {
    display: none;
  }
}

@supports (-ms-ime-align: auto) {
  .success-message svg {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wardrobe/clothes/CreateOutfit.vue